export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.citycourier.org/api/v1';

// Helper function to get auth token
export const getAuthToken = (): string | null => {
    return localStorage.getItem('token');
};

// Common authenticated headers
export const getAuthHeaders = (): HeadersInit => {
    const token = getAuthToken();
    const headers: HeadersInit = {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return headers;
};

// Helper function to handle API errors
export const handleApiError = async (response: Response): Promise<never> => {
    let errorMessage = 'An error occurred';
    
    try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorData.error || errorMessage;
    } catch {
        // If we can't parse the error response, use the status text
        errorMessage = response.statusText || errorMessage;
    }
    
    throw new Error(errorMessage);
};
